import type { SettingsState } from '@/contexts/settings/types';
import type { Components, Theme } from '@mui/material/styles';

import { cardClasses } from '@mui/material/Card';

// ----------------------------------------------------------------------

export function applySettingsToComponents(settingsState?: SettingsState): {
  components: Components<Theme>;
} {
  const MuiCssBaseline: Components<Theme>['MuiCssBaseline'] = {
    styleOverrides: (theme) => ({
      html: {
        fontSize: settingsState?.fontSize
      },
      body: {
        [`& .${cardClasses.root}`]: {
          ...(settingsState?.contrast === 'high' && {
            '--card-shadow': theme.vars.customShadows.z1
          })
        }
      }
    })
  };

  return {
    components: {
      MuiCssBaseline
    }
  };
}
